import { render } from "./demoUserStatus1.vue?vue&type=template&id=82807a94"
import script from "./demoUserStatus1.vue?vue&type=script&lang=js"
export * from "./demoUserStatus1.vue?vue&type=script&lang=js"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__